import { FoundationElement } from "../foundation-element/foundation-element.js";
/**
 * A List Picker Menu Custom HTML Element.
 *
 * @alpha
 */
export class PickerList extends FoundationElement {
}
